import { Box, Grid, styled } from "@mui/material";

export const ItemBox = styled(Grid)({
  alignItems: "center",
  padding: "5px",
  borderRadius: "25px",
  minWidth: "250px",
  minHeight: "80px",
  marginTop: "10px",
  marginBottom: "10px",
  boxShadow: "0px 2px 5px #c2c1c1",
  transitionDuration: "0.2s",
  backgroundColor: "#ffffff",
  color: "#5f5f5f",
});
export const TableValues = styled(Box)({
  height: "45px",
  textAlign: "left",
  paddingLeft: "10px",
  display: "grid",
  alignItems: "center",
  gridTemplateColumns: "33% 33% 33%",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "rgb(160,160,255)",
});
export const TableHead = styled(Box)({
  backgroundColor: "#4EAF50",
  height: "55px",
  position: "relative",
  textAlign: "left",
  paddingLeft: "10px",
  display: "grid",
  alignItems: "center",
  color: "white",
  gridTemplateColumns: "33% 33% 33%",
  marginTop: "10px",
});
